
import { TServiceResult } from "./TServiceResult";

export class Therm
{
    SmokeID: string = "";
    ThermID: string = "";
    Description: string = "";
}

export type ServiceTherms = TServiceResult<Therm[]>;

export const EmptyServiceTherms: ServiceTherms =
{
    TheValue: [],
    Result: false,
    Reason: "Not initialized",
    CorrelationID: "",
    Succeeded: false
}